/** Validation for manual Bugsnap titles (plain text only). */

const EMOJI_RE = /\p{Extended_Pictographic}/gu

export const BUG_REPORT_TITLE_EMOJI_ERROR =
  'Bug titles cannot contain emoji. Use plain text only.'

export function containsEmoji(text: string): boolean {
  return /\p{Extended_Pictographic}/u.test(text)
}

export function stripEmoji(text: string): string {
  return text.replace(EMOJI_RE, '')
}

export function validateBugReportTitle(title: string): string | null {
  if (containsEmoji(title)) {
    return BUG_REPORT_TITLE_EMOJI_ERROR
  }
  return null
}
